import {Locale} from '../../../RootProvider/LocaleContext';
import {FormatMessageFunction, LinkProp} from '../../../types';

export const getFinanceByType = (formatMessage: FormatMessageFunction, locale: Locale): LinkProp[] => {
  let links: LinkProp[];

  switch (locale) {
    case Locale.nl:
      links = [
        {
          label: formatMessage({id: 'knowledgePages.link.businessLoans.text'}),
          href: formatMessage({id: 'knowledgePages.link.businessLoans.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.factoring.text'}),
          href: formatMessage({id: 'knowledgePages.link.factoring.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.assetFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.assetFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.workingCapitalFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.workingCapitalFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.flexibleCredit.text'}),
          href: formatMessage({id: 'knowledgePages.link.flexibleCredit.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.pinCredit.text'}),
          href: formatMessage({id: 'knowledgePages.link.pinCredit.href'}),
        },
      ];
      break;
    default:
      links = [
        {
          label: formatMessage({id: 'knowledgePages.link.businessLoans.text'}),
          href: formatMessage({id: 'knowledgePages.link.businessLoans.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.invoiceFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.invoiceFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.assetFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.assetFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.commercialPropertyFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.commercialPropertyFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.workingCapitalFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.workingCapitalFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.revolvingCreditFacility.text'}),
          href: formatMessage({id: 'knowledgePages.link.revolvingCreditFacility.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.merchantCashAdvance.text'}),
          href: formatMessage({id: 'knowledgePages.link.merchantCashAdvance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.auctionFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.auctionFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.equipmentFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.equipmentFinance.href'}),
        },
        {
          label: formatMessage({id: 'knowledgePages.link.tradeFinance.text'}),
          href: formatMessage({id: 'knowledgePages.link.tradeFinance.href'}),
        },
      ];
  }

  return links;
};

export const getFinanceBySituation = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const links = [
    {
      label: formatMessage({id: 'knowledgePages.link.loansForBadCredit.text'}),
      href: formatMessage({id: 'knowledgePages.link.loansForBadCredit.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.growSmallBusiness.text'}),
      href: formatMessage({id: 'knowledgePages.link.growSmallBusiness.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.dealingWithLatePayments.text'}),
      href: formatMessage({id: 'knowledgePages.link.dealingWithLatePayments.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.financeForNonHomeowners.text'}),
      href: formatMessage({id: 'knowledgePages.link.financeForNonHomeowners.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.refinanceBusinessDebt.text'}),
      href: formatMessage({id: 'knowledgePages.link.refinanceBusinessDebt.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.businessFinanceWithCCJ.text'}),
      href: formatMessage({id: 'knowledgePages.link.businessFinanceWithCCJ.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.financeTaxVatBill.text'}),
      href: formatMessage({id: 'knowledgePages.link.financeTaxVatBill.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.mezzanineFinance.text'}),
      href: formatMessage({id: 'knowledgePages.link.mezzanineFinance.href'}),
    },
  ];
  return links;
};

export const getHowToGuides = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const links = [
    {
      label: formatMessage({id: 'knowledgePages.link.personalGuarantees.text'}),
      href: formatMessage({id: 'knowledgePages.link.personalGuarantees.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.buyingPropertyAtAuction.text'}),
      href: formatMessage({id: 'knowledgePages.link.buyingPropertyAtAuction.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.businessOverdraftAlternatives.text'}),
      href: formatMessage({id: 'knowledgePages.link.businessOverdraftAlternatives.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.managingCashflow.text'}),
      href: formatMessage({id: 'knowledgePages.link.managingCashflow.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.propertyDevelopers.text'}),
      href: formatMessage({id: 'knowledgePages.link.propertyDevelopers.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.securedVsUnsecuredLoans.text'}),
      href: formatMessage({id: 'knowledgePages.link.securedVsUnsecuredLoans.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.emergencyBusinessFinance.text'}),
      href: formatMessage({id: 'knowledgePages.link.emergencyBusinessFinance.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.commercialLoans.text'}),
      href: formatMessage({id: 'knowledgePages.link.commercialLoans.href'}),
    },
    {
      label: formatMessage({id: 'knowledgePages.link.bridgingLoansBridgingFinance.text'}),
      href: formatMessage({id: 'knowledgePages.link.bridgingLoansBridgingFinance.href'}),
    },
  ];
  return links;
};
